var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"check-box",on:{"click":_vm.clickHandler}},[_c('div',{staticClass:"checked"},[(_vm.isChecked)?_c('img',{staticClass:"check-img",attrs:{"src":require('@/assets/icons/check.svg')}}):_vm._e()]),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }